let sequence = 0;

const makeClientId = () => {
  sequence += 1;
  return `stat-${Date.now()}-${sequence}`;
};

export const STATISTIC_FIELDS = [
  'date',
  'Hit',
  'Speed',
  'Speed2',
  'Speed_s_razbega',
  'Speed_s_razbega2',
  'Reaction',
  'Jump',
  'Jump2',
  'sharpshooting',
  'Agility',
  'FootSkill',
  'FootSkill2',
  'MessiTestDriblingTest',
  'ExstraColorDriblingTest',
  'MessiTestDriblingTest2',
  'ExstraColorDriblingTest2',
];

export const NUMERIC_STATISTIC_FIELDS = STATISTIC_FIELDS.filter((field) => field !== 'date');
const numericFields = new Set(NUMERIC_STATISTIC_FIELDS);

export const createStatistic = (date = '') => ({
  clientId: makeClientId(),
  date,
  ...NUMERIC_STATISTIC_FIELDS.reduce((result, field) => ({ ...result, [field]: '' }), {}),
});

export const attachClientIds = (rows = []) =>
  (Array.isArray(rows) ? rows : []).map((row) => ({
    ...row,
    clientId: row.clientId || makeClientId(),
  }));

export const duplicateStatistic = (row) => {
  const { id, clientId, ...copy } = row || {};
  return {
    ...copy,
    clientId: makeClientId(),
  };
};

export const updateStatistic = (rows, clientId, field, rawValue) =>
  (rows || []).map((row) => {
    if (row.clientId !== clientId) return row;
    let value = rawValue;
    if (numericFields.has(field)) {
      value = rawValue === '' ? '' : Number(rawValue);
    }
    return { ...row, [field]: value };
  });

export const removeStatistic = (rows, clientId) =>
  (rows || []).filter((row) => row.clientId !== clientId);

const isPresent = (value) => value !== '' && value !== null && value !== undefined;

export const hasStatisticMeasurements = (row = {}) =>
  NUMERIC_STATISTIC_FIELDS.some((field) => isPresent(row[field]) && Number.isFinite(Number(row[field])));

export const validateStatisticsForSave = (rows = []) => {
  const invalidIndex = (Array.isArray(rows) ? rows : []).findIndex(
    (row) => hasStatisticMeasurements(row) && !String(row.date || '').trim()
  );

  if (invalidIndex >= 0) {
    return {
      valid: false,
      error: `Укажите дату тестирования для результата №${invalidIndex + 1}.`,
    };
  }

  return { valid: true, error: '' };
};

export const sanitizeStatisticsForStrapi = (rows = []) =>
  (Array.isArray(rows) ? rows : [])
    .filter(hasStatisticMeasurements)
    .map((row) => {
      const clean = {};
      if (row.id !== undefined && row.id !== null) clean.id = row.id;
      if (String(row.date || '').trim()) clean.date = String(row.date).trim();

      NUMERIC_STATISTIC_FIELDS.forEach((field) => {
        if (!isPresent(row[field])) return;
        const value = Number(row[field]);
        if (Number.isFinite(value)) clean[field] = value;
      });

      return clean;
    });
